import type { EquipmentResponse } from "../../components/shared/EquipmentDropdown.types";

const sharedLoad = {
  bills: 30,
  pallets: 19,
  pieces: 7,
  handlingUnits: 12,
  weight: 30000,
  shipmentTags: [],
};

const emptyLoad = {
  bills: 0,
  weight: 0,
  pallets: 0,
  pieces: 0,
  handlingUnits: 0,
  shipmentTags: [],
};

export const centralizedEquipmentBySicMock = {
  default: {
    available: [
      {
        equipmentId: 101,
        refNumber: "DYLT242201",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: sharedLoad,
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T10:00:00",
        daysAging: 2,
      },
      {
        equipmentId: 201,
        refNumber: "TRC-10001",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: sharedLoad,
        equipmentType: { id: 1, name: "Tractor" },
        lengthFt: null,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T09:00:00",
        daysAging: 0,
      },
      {
        equipmentId: 301,
        refNumber: "ST-5001",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: sharedLoad,
        equipmentType: { id: 3, name: "Straight Truck" },
        lengthFt: 26,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T08:00:00",
        daysAging: 1,
      },
      {
        equipmentId: 401,
        refNumber: "FOR-0001",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: emptyLoad,
        equipmentType: { id: 4, name: "Forklift" },
        lengthFt: null,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T07:30:00",
        daysAging: 0,
      },
      {
        equipmentId: 402,
        refNumber: "530-1026",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: emptyLoad,
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T06:45:00",
        daysAging: 0,
      },
    ],
    assigned: [
      {
        equipmentId: 102,
        refNumber: "DYLT195042",
        doorNumber: null,
        status: { id: 10, name: "ENRT" },
        assignedTo: {
          id: 389289,
          type: "Route",
          name: "ANA-1",
          tractor: { id: 389289, name: "389289" },
          trailer: { id: 102, name: "DYLT195042" },
          status: "CARV",
          linehaulInfo: null,
          planDate: "2026-03-17T08:00:00",
          actualArrivalTime: "2026-03-17T07:45:00",
        },
        homeSicId: 111,
        loadSummary: sharedLoad,
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "F", ownershipScacCode: "YYE" },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T07:00:00",
        daysAging: 0,
      },
      {
        equipmentId: 103,
        refNumber: "DYLT205016",
        doorNumber: null,
        status: { id: 15, name: "LDDK" },
        assignedTo: {
          id: 102030,
          type: "Trip",
          name: "102030",
          status: "LDDK",
          linehaulInfo: { originSicId: 111, destinationSicId: 222 },
          planDate: "2026-03-17T06:00:00",
          actualArrivalTime: null,
        },
        homeSicId: 111,
        loadSummary: sharedLoad,
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T06:00:00",
        daysAging: 0,
      },
      {
        equipmentId: 501,
        refNumber: "280-4001",
        doorNumber: null,
        status: { id: 221, name: "DEPT" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: emptyLoad,
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T05:30:00",
        daysAging: 0,
      },
      {
        equipmentId: 502,
        refNumber: "DYLT300010",
        doorNumber: null,
        status: { id: 15, name: "LDDK" },
        assignedTo: {
          id: 775500,
          type: "Trap",
          name: "775500",
          status: "LDDK",
          linehaulInfo: { originSicId: 111, destinationSicId: 333 },
          planDate: "2026-03-17T05:00:00",
          actualArrivalTime: null,
        },
        homeSicId: 111,
        loadSummary: sharedLoad,
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 53,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-17T04:45:00",
        daysAging: 0,
      },
    ],
    loadAndHold: [
      {
        equipmentId: 104,
        refNumber: "ABC-123",
        doorNumber: null,
        status: { id: 15, name: "EMTY" },
        assignedTo: {
          id: 869430,
          type: "Trip",
          name: "869430",
          status: "LDDK",
          linehaulInfo: null,
          planDate: "2026-03-16T10:30:00",
          actualArrivalTime: null,
        },
        homeSicId: 111,
        loadSummary: sharedLoad,
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 48,
        ownership: { ownershipType: "F", ownershipScacCode: "ORGN" },
        currentSealNumber: null,
        lastUpdateDate: "2026-03-16T10:30:00",
        daysAging: 1,
      },
    ],
  } satisfies EquipmentResponse,
};
